import UserAboutBasic from '@/pages/user/pages/about/pages/basic'
import UserAboutBackgrounds from '@/pages/user/pages/about/pages/backgrounds'
import UserAboutGuardians from '@/pages/user/pages/about/pages/guardians'
const ROOT = ''
export default {
  routes: [
    {
      path: ROOT + 'basic',
      name: 'UserAboutBasic',
      meta: {
        group: 'UserAbout',
        requireAuth: true,
        icon: ['fal', 'user'],
        label: '基本情報',
        permit: 'about'
      },
      component: UserAboutBasic
    },
    {
      path: ROOT + 'guardians',
      name: 'UserAboutGuardians',
      meta: {
        group: 'UserAbout',
        requireAuth: true,
        icon: ['fal', 'users'],
        label: '保護者様',
        permit: 'about'
      },
      component: UserAboutGuardians
    },
    {
      path: ROOT + 'backgrounds',
      name: 'UserAboutBackgrounds',
      meta: {
        group: 'UserAbout',
        requireAuth: true,
        icon: ['fal', 'list-ul'],
        label: '補足情報',
        permit: 'about'
      },
      component: UserAboutBackgrounds
    }
  ]
}
